/*eslint-disable */
import toast from '@/services/toast';
import { Datetime } from 'vue-datetime';
// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'
export default {
  name: 'activity-tracker-user-list',
  components: {
    datetime: Datetime,
  },
  props: [],
  data () {
    return {
      getActivityTrackerListData:null,
      getActivityTrackerListDataResults:[],
      start_date_for_f:'',
      end_date__for_f:'',
      start_date:'',
      end_date:'',
      date:new Date(),
      maxDatetime:new Date().toISOString(),
      submitted:false,
      apiResLoader:false
    }
  },
  computed: {

  },
  mounted () {
    const previous = new Date(this.date.getTime());
    previous.setDate(this.date.getDate() - 1);
    this.start_date = previous;
    this.end_date = new Date()
    this.getActivityTrackerListMethod();
  },
  methods: {
    coreTeamFilterMethod(){
      this.$validator.validateAll().then((result) => {
        if (result) {
          if(this.start_date_for_f > this.end_date__for_f){
            toast.error('Oops your end date is in an incorrect format. Please input again.')
          }else{
            this.submitted = true
            this.apiResLoader = true
            let data = {
              start_date : this.start_date_for_f,
              end_date : this.end_date__for_f
            }        
            this.$store.dispatch('getActivityTrackerListFun', data).then((res) => {
              this.getActivityTrackerListData = res.data.data
              this.getActivityTrackerListDataResults = this.getActivityTrackerListData.results
              this.start_date =  this.start_date_for_f
              this.end_date =  this.end_date__for_f
              this.submitted = false
              this.apiResLoader = false
            }).catch((err) => {
              this.submitted = false
              this.apiResLoader = false
            })
          }
        }
      })
    },
    getActivityTrackerListMethod(){
      let data = {
        start_date : this.start_date,
        end_date : this.end_date
      }        
      this.$store.dispatch('getActivityTrackerListFun', data).then((res) => {
        this.getActivityTrackerListData = res.data.data
        this.getActivityTrackerListDataResults = this.getActivityTrackerListData.results
      })
    },
  }
}


